import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const VARIANT_CONFIG = {
  success: { color: "rgba(25, 135, 84)", icon: "fa-circle-check" },
  warning: { color: "rgba(255, 193, 7)", icon: "fa-triangle-exclamation" },
  error: { color: "rgba(220, 53, 69)", icon: "fa-circle-xmark" },
};

function AppToast({ show, onClose, variant = "success", message, delay = 4000 }) {
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.success;
  const textClass = variant === "warning" ? "text-dark" : "text-white";
  // Error toasts must be dismissed manually via the close button
  const shouldAutoHide = variant !== "error";

  return (
    <ToastContainer
      position="top-center"
      style={{ zIndex: 9999, marginTop: "70px" }}
    >
      <Toast
        show={show}
        onClose={onClose}
        autohide={shouldAutoHide}
        delay={shouldAutoHide ? delay : undefined}
        style={{ minWidth: "400px", backgroundColor: config.color }}
      >
        <Toast.Body className={`${textClass} d-flex align-items-center justify-content-between`}>
          <span className="d-flex align-items-center">
            <i className={`fa-solid ${config.icon} me-2`}></i>
            {message}
          </span>
          {!shouldAutoHide && (
            <button
              type="button"
              className="btn-close btn-close-white ms-3"
              aria-label="Close"
              onClick={onClose}
            />
          )}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default AppToast;
